// extracted by mini-css-extract-plugin
module.exports = {"Container":"📚4-7-0zZzbJ"};